<template>
  <v-container fluid grid-list-xl>
    <app-monitoramento
      :acesso="acesso"
      :fim="diagnostico.fimResponsabilidadeChefia"
      :inicio="diagnostico.inicioResponsabilidadeChefia"
      monitoramento="diagnostico"
      perspectiva="COMPORTAMENTAL"
      titulo="Diagnóstico Comportamental"
    >
      <template v-slot:body>
        <v-col centered cols="12" no-gutters>
          <v-row class="justify-center ma-2">
            <v-tabs v-model="categoria" centered icons-and-text>
              <v-tabs-slider color="secondary" />
              <v-tab
                v-for="i in categorias.length"
                :key="i"
                :href="'#' + categorias[i - 1].id"
                class="mt-3"
              >
                <span class="grey--text text--darken-2">{{
                  categorias[i - 1].descricao
                }}</span>
                <v-icon
                  :color="
                    categorias[i - 1].id === categoria ? 'secondary' : 'grey'
                  "
                >
                  {{ categorias[i - 1].icone }}
                </v-icon>
              </v-tab>
            </v-tabs>
          </v-row>
          <v-row class="justify-center ma-1">
            <v-col cols="12">
              <v-row>
                <v-toolbar flat>
                  <v-toolbar-title>
                    <h2
                      class="
                        title
                        primary--text
                        text--darken-1 text-no-wrap
                        mt-0
                      "
                    >
                      FILTROS
                    </h2>
                  </v-toolbar-title>
                </v-toolbar>
              </v-row>
              <v-row>
                <select-multiple-unidades
                  v-model="unidades"
                  :mapeamento-id="diagnostico.mapeamento.id"
                />
              </v-row>
            </v-col>
            <v-col v-if="relatorios.length > 0" cols="12">
              <v-row>
                <v-toolbar flat>
                  <v-toolbar-title>
                    <h2
                      class="
                        title
                        primary--text
                        text--darken-1 text-no-wrap
                        mt-0
                      "
                    >
                      {{ `GRÁFICOS ${unidades.visualizacao}` }}
                    </h2>
                  </v-toolbar-title>
                </v-toolbar>
              </v-row>
              <v-row id="grafico-gauge" ref="graficos" class="justify-center">
                <v-col cols="12">
                  <gauge-chart
                    :dados="gaugeChart"
                    :fonte="`Fonte: Sistema Desenvolva, ${anoDiagnostico}`"
                    :maximo="100"
                    :minimo="0"
                    :titulo="`Participação do Diagnóstico Comportamental ${unidades.visualizacao}`"
                    descricao="Percentual de Conclusão da(s) Unidade(s)"
                    descricao-titulo="Participação do Diagnóstico Comportamental"
                    formato="%"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <tabela-quadro-resumo
                    :relatorios="relatorios"
                    :titulo="`QUADRO RESUMO DO DIAGNÓSTICO COMPORTAMENTAL ${unidades.visualizacao}`"
                    perspectiva="COMPORTAMENTAL"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <tabela-resultados
                    :relatorios="relatorios"
                    :titulo="`RESULTADOS ${unidades.visualizacao}`"
                    perspectiva="COMPORTAMENTAL"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <tabela-dispensados
                    :relatorios="relatorios"
                    :titulo="`SERVIDORES DISPENSADOS ${unidades.visualizacao}`"
                  />
                </v-col>
              </v-row>
              <!-- Relatório PDF -->
              <v-row
                class="justify-end mb-1"
              >
                <botao-PDF
                  :relatorios="relatorios"
                  :diagnostico="diagnostico"
                  :unidades-visualizacao="unidades.visualizacao"
                  perspectiva="COMPORTAMENTAL"
                />
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </template>
    </app-monitoramento>
  </v-container>
</template>

<script>
import _ from 'lodash';
import { mapGetters, mapState } from 'vuex';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import AppMonitoramento from '@/components/core/AppMonitoramento';
import SelectMultipleUnidades from '@/components/SelectMultipleUnidades';
import GaugeChart from '@/components/chart/GaugeChart';
import TabelaQuadroResumo from '@/components/monitoramento/diagnostico/TabelaQuadroResumo';
import TabelaDispensados from '@/components/monitoramento/diagnostico/TabelaDispensados';
import TabelaResultados from '@/components/monitoramento/diagnostico/TabelaResultados';
import BotaoPDF from '@/components/monitoramento/diagnostico/BotaoPDF';

const avaliacoesRepository = RepositoryFactory.get('avaliacao');

export default {
  name: 'MonitoramentoUnidadeDiagnostico',

  components: {
    AppMonitoramento,
    SelectMultipleUnidades,
    GaugeChart,
    TabelaQuadroResumo,
    TabelaDispensados,
    TabelaResultados,
    BotaoPDF,
  },

  data() {
    return {
      acesso: null,
      categorias: [
        {
          id: 'DiagnosticoComportamental',
          descricao: 'Diagnóstico Comportamental',
          icone: 'speed',
        },
      ],
      categoria: '',
      unidades: {
        isTodasSelecionadas: null,
        selecionado: [],
        visualizacao: '',
      },
      relatorios: [],
    };
  },

  computed: {
    ...mapState({
      isTutorialExibido: (state) => state.tutorial.dados.monitoramentoDiagnosticoComportamental,
      comissao: (state) => state.auth.comissao,
      chefia: (state) => state.auth.chefia,
      substituicaoChefia: (state) => state.auth.substituicaoChefia,
    }),
    ...mapGetters({
      getDiagnostico: 'diagnostico/getDiagnostico',
    }),
    diagnostico() {
      return this.getDiagnostico(this.acesso);
    },
    anoDiagnostico() {
      return this.diagnostico ? this.diagnostico.ano : '';
    },
    gaugeChart() {
      if (this.relatorios.length) {
        const totalConcluidos = _.sumBy(this.relatorios, 'totaisComportamental.totalConcluidos');
        const totalPendentes = _.sumBy(this.relatorios, 'totaisComportamental.totalPendentes');

        if (totalConcluidos > 0) {
          return [(totalConcluidos * 100) / (totalConcluidos + totalPendentes)];
        }
      }
      return [0];
    },
  },

  watch: {
    diagnostico() {
      this.unidades = {
        isTodasSelecionadas: null,
        selecionado: [],
        visualizacao: '',
      };
    },
    'unidades.selecionado': function (nv) {
      if (nv.length) {
        this.load();
      } else {
        this.relatorios = [];
      }
    },
  },

  created() {
    if (this.comissao) {
      this.acesso = 'COMISSAO';
    } else if (this.chefia || this.substituicaoChefia) {
      this.acesso = 'COMUM';
    } else {
      this.$router.push('/403');
    }
  },

  mounted() {
    if (!this.isTutorialExibido && this.acesso) {
      this.$store.dispatch('app/showTutorial', { nome: 'MonitoramentoDiagnosticoComportamental' });
    }
  },

  methods: {
    load() {
      const unidadesIds = this.unidades.selecionado.map((u) => u.idVersao);
      avaliacoesRepository.relatorios(this.diagnostico.id, unidadesIds).then((res) => {
        this.relatorios = res.data;
      });
    },
  },
};
</script>
